import { defineMessages } from 'react-intl';

export default defineMessages({
    choseProducerCodePlaceholder: {
        id: 'gateway.views.new-quote.Choose Producer Code',
        defaultMessage: '--Please Select--', // DE15926
    },
    choseProductPlaceholder: {
        id: 'gateway.views.new-quote.Choose Product',
        defaultMessage: '--Please Select--',
    },
    producerCode: {
        id: 'gateway.views.new-quote.Producer Code',
        defaultMessage: 'Producer Code & Name',
    },
    emailAddress: {
        id: 'gateway.views.new-quote.Email',
        defaultMessage: 'Account Holder Email Address',
    },
    addressTitle: {
        id: 'gateway.views.new-quote.Address title',
        defaultMessage: 'Address of property to be insured',
    },
    dateOfBirth: {
        id: 'gateway.views.new-quote.Date of Birth',
        defaultMessage: 'Date of birth',
    },
    TFPAIndividual: {
        id: 'gateway.views.new-quote.TFPA Individual',
        defaultMessage: 'Individual',
    },
    TWIAPersonal: {
        id: 'gateway.views.new-quote.TWIA Personal',
        defaultMessage: 'Personal',
    },
    TWIAOrganization: {
        id: 'gateway.views.new-quote.TWIA Organization',
        defaultMessage: 'Organization',
    },
    TWIAEmailInfo: {
        id: 'gateway.views.new-quote.TWIA Email Info',
        defaultMessage: 'If the customer wants to utilize the TWIA Policyholder Portal to view documents, view invoices, make payments via echeck or credit card, or select the TWIA 10 Pay Auto Pay Plan, an email address will be required.',
    },
    TWIAProducerEmailError: {
        id: 'gateway.views.new-quote.TWIA Producer Email Error',
        defaultMessage: 'Account Holder Email Address should not be for a user in your organization.',
    },
    mustBeValidEmailAddress:{
        id: 'gateway.views.new-quote.Must be a valid Email Address.',
        defaultMessage: 'Value must be a valid email address.'
    },
    requiredField: {
        id: 'gateway.views.new-quote.required field',
        defaultMessage: 'This is a required field.',
    },
    createAccount: {
        id: "gateway.views.new-quote.Create Account",
        defaultMessage: "Create Account"
    },
});
